import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  balanceVal: 0,
};

// 创建一个 Slice 
export const balanceSlice = createSlice({
  name: 'balance',
  initialState,
  reducers: {
    setBalance: (state, action) => {
      // console.log(val, 123)
      state.balanceVal = action.payload;
    },
  },
});
// 导出加减的方法
export const { setBalance } = balanceSlice.actions;

// 默认导出
export default balanceSlice.reducer;